import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import classes from './LogMenu.module.scss';

import Modal from '../UI/Modal';
import LoginSection from './LoginSection';
import SignupSection from './SignupSection';
import OrDivider from './OrDivider';
import FormSection from './FormSection';

export default function LogMenu({ closeModal, initialSignup }) {
  const [isClosing, setIsClosing] = useState(false);
  const [isSignup, setIsSignup] = useState(initialSignup);
  const [isTouched, setIsTouched] = useState(false);
  const [isFormSignup, setFormSignup] = useState(initialSignup);
  const { t, i18n } = useTranslation('authForm');

  const language = i18n.language;

  function handleClose() {
    setIsClosing(true);
    setTimeout(() => {
      closeModal();
      setIsClosing(false);
    }, 1000);
  }

  useEffect(() => {
    if (isSignup) {
      setFormSignup(isSignup);
    } else {
      const timerId = setTimeout(() => {
        setFormSignup(isSignup);
      }, 100);
      return () => clearTimeout(timerId);
    }
  }, [isSignup]);

  return (
    <Modal onClose={handleClose} isClosing={isClosing}>
      <div
        className={`${classes.modalContainer} ${
          isClosing ? classes.closingAnimation : ''
        }`}
      >
        <LoginSection
          isSignup={isSignup}
          isTouched={isTouched}
          setIsSignup={setIsSignup}
          setIsTouched={setIsTouched}
          t={t}
          language={language}
        />
        <SignupSection
          isSignup={isSignup}
          isTouched={isTouched}
          setIsSignup={setIsSignup}
          setIsTouched={setIsTouched}
          t={t}
          language={language}
        />
        <OrDivider
          isSignup={isSignup}
          isTouched={isTouched}
          t={t}
          language={language}
        />
        <FormSection
          isFormSignup={isFormSignup}
          isSignup={isSignup}
          t={t}
          language={language}
          closeHandler={handleClose}
        />
      </div>
    </Modal>
  );
}
